import { connect } from "react-redux";
import ChangeAssignee from "./changeAssignee";
import { bindActionCreators } from "redux";
import {
    getAssigneeList,
    postAssignee
} from "services/redux/sales/changeAssignee/action";

const mapStateToProps = (state) => ({
    assigneeList: state.assigneeReducer.assigneeList,
    statusList: state.preSalesListReducer.statusList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAssigneeList,
            postAssignee
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ChangeAssignee);
